exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".team{margin-bottom:50px}.team>.row{margin-top:50px}@media screen and (min-width:768px){.team p{font-size:1.6rem}}.team__title{margin-bottom:12.5px;font-size:1.8rem;font-weight:400}@media screen and (min-width:480px){.team__title{font-size:2.5rem}}@media screen and (min-width:900px){.team__title{font-size:2.8rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/routes/team.styl
// module id = 538
// module chunks = 0